module.exports = __webpack_public_path__ + "3111f2825f1529b0ac9384b1c0d705f6.pdf";